import { render, staticRenderFns } from "./Exemption.vue?vue&type=template&id=72a01c52&scoped=true&"
var script = {}
import style0 from "./Exemption.vue?vue&type=style&index=0&id=72a01c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a01c52",
  null
  
)

export default component.exports